import type { FC } from 'react';
import React from 'react';
import type { WrappedComponentProps } from 'react-intl';
import { injectIntl } from 'react-intl';

import ChevronRightIcon from '@atlaskit/icon/core/chevron-right';
import { LinkItem } from '@atlaskit/menu';

import { ThemePopupMenu } from '@confluence/theming/entry-points/ThemePopupMenu.ts';

import type { PopupMenuItem } from './PopupMenuItem.tsx';

const ThemeMenuItemComponent: FC<PopupMenuItem & WrappedComponentProps> = ({
	item,
	isSelected,
	closeMenu,
	...linkItemProps
}) => {
	return (
		<ThemePopupMenu
			isOpen={isSelected}
			onSelected={closeMenu}
			closeMenu={linkItemProps.onClick}
			trigger={({ triggerRef, ...triggerProps }) => (
				<LinkItem
					{...triggerProps}
					{...linkItemProps}
					isSelected={isSelected}
					iconAfter={<ChevronRightIcon spacing="spacious" label="" size="small" />}
					ref={triggerRef}
				>
					{item.content}
				</LinkItem>
			)}
		/>
	);
};

export const ThemeMenuItem = injectIntl(ThemeMenuItemComponent);
